// import React, { useState } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   useTheme,
//   useMediaQuery,
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Stack,
//   Chip as MuiChip,
//   Pagination,
//   Button,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// const CompaniesHeader = () => {
//   const theme = useTheme();
//   const isXs = useMediaQuery(theme.breakpoints.down("sm"));
//   const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
//   const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

//   // Local state for dropdown
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("All");
//   const open = Boolean(anchorEl);
//   // Handle dropdown open
//   const handleDropdownClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   // Handle dropdown close
//   const handleDropdownClose = () => {
//     setAnchorEl(null);
//   };
//   const dropdownStyles = `
//     .dropdown-container {
//       position: relative;
//       display: inline-block;
//     }

//     .dropdown-menu {
//       position: absolute;
//       top: 100%;
//       left: 0;
//       right: 0;
//       background: white;
//       border: 1px solid #e5e7eb;
//       border-radius: 6px;
//       box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
//       z-index: 1000;
//       margin-top: 2px;
//       overflow: hidden;
//     }

//     .dropdown-item {
//       padding: 10px 16px;
//       cursor: pointer;
//       font-family: Roboto;
//       font-size: 14px;
//       color: #595959;
//       border: none;
//       background: none;
//       width: 100%;
//       text-align: left;
//       transition: background-color 0.2s ease;
//     }

//     .dropdown-item:hover {
//       background-color: #f9fafb;
//     }

//     .dropdown-item.selected {
//       background-color: #f3f4f6;
//     }
//   `;
//   const DropdownIcon = () => (
//     <svg
//       width="12"
//       height="12"
//       viewBox="0 0 12 12"
//       fill="none"
//       style={{ marginLeft: "8px" }}
//     >
//       <path
//         d="M3 4.5L6 7.5L9 4.5"
//         stroke="#9CA3AF"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );

//   // Handle status selection
//   const handleStatusSelect = (status) => {
//     setSelectedStatus(status);
//     handleDropdownClose();
//   };

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", sm: "column", md: "row" },
//           justifyContent: "space-between",
//           alignItems: { xs: "stretch", sm: "stretch", md: "center" },
//           p: { xs: 2, sm: 3, md: "24px 32px" },
//           borderBottom: "1px solid #f0f1f3",
//           backgroundColor: "white",
//           gap: { xs: 2, sm: 2, md: 0 },
//           ml: "230px",
//         }}
//       >
//         <Typography
//           variant="h4"
//           sx={{
//             fontSize: { xs: "20px", sm: "22px", md: "24px" },
//             fontWeight: "600",
//             color: "#1a202c",
//             mb: { xs: 0, sm: 0, md: 0 },
//             textAlign: { xs: "left", sm: "left", md: "left" },
//           }}
//         >
//           All companies
//         </Typography>

//         {/* Filters and Controls */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", sm: "row" },
//             alignItems: { xs: "stretch", sm: "center" },
//             gap: { xs: 1.5, sm: 2 },
//             flexWrap: "wrap",
//           }}
//         >
//           {/* Filter Dropdowns Row */}
//           <Box
//             sx={{
//               display: "flex",
//               gap: { xs: 1, sm: 1.5 },
//               flexWrap: "wrap",
//               width: { xs: "100%", sm: "auto" },
//             }}
//           >
//             {/* Add styles to head */}
//             <style dangerouslySetInnerHTML={{ __html: dropdownStyles }} />

//             {/* Activity Status Dropdown */}
//             <div className="dropdown-container">
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   p: { xs: "6px 12px", sm: "8px 16px" },
//                   borderRadius: "6px",
//                   fontSize: { xs: "12px", sm: "14px" },
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                   minWidth: { xs: "0", sm: "120px" },
//                   justifyContent: "center",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 600,
//                   color: "#595959",
//                 }}
//                 onClick={handleDropdownClick}
//               >
//                 {selectedStatus}
//                 <DropdownIcon />
//               </Box>

//               {/* Custom Dropdown Menu */}
//               {open && (
//                 <div className="dropdown-menu">
//                   <button
//                     className={`dropdown-item ${
//                       selectedStatus === "All" ? "selected" : ""
//                     }`}
//                     onClick={() => handleStatusSelect("All")}
//                   >
//                     All
//                   </button>
//                   <button
//                     className={`dropdown-item ${
//                       selectedStatus === "Active" ? "selected" : ""
//                     }`}
//                     onClick={() => handleStatusSelect("Active")}
//                   >
//                     Active
//                   </button>
//                   <button
//                     className={`dropdown-item ${
//                       selectedStatus === "Inactive" ? "selected" : ""
//                     }`}
//                     onClick={() => handleStatusSelect("Inactive")}
//                   >
//                     Inactive
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Click outside to close */}
//             {open && (
//               <div
//                 style={{
//                   position: "fixed",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   zIndex: 999,
//                 }}
//                 onClick={handleDropdownClose}
//               />
//             )}
//           </Box>

//           {/* Search and Export Row */}
//           <Box
//             sx={{
//               display: "flex",
//               gap: { xs: 1, sm: 2 },
//               width: { xs: "100%", sm: "auto" },
//               flexDirection: { xs: "column", sm: "row" },
//             }}
//           >
//             {/* Search Input */}
//             <Box
//               sx={{
//                 position: "relative",
//                 display: "flex",
//                 alignItems: "center",
//                 flex: { xs: "1", sm: "0 0 auto" },
//               }}
//             >
//               <input
//                 type="text"
//                 placeholder="Search with name"
//                 style={{
//                   padding: isXs ? "8px 40px 8px 12px" : "10px 44px 10px 16px",
//                   borderRadius: "6px",
//                   fontSize: isXs ? "13px" : "14px",
//                   width: "100%",
//                   backgroundColor: "white",
//                   outline: "none",
//                   transition: "all 0.2s ease",
//                   boxSizing: "border-box",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 400,
//                   color: "#848694",
//                 }}
//                 onFocus={(e) => {
//                   e.target.style.borderColor = "#3b82f6";
//                   e.target.style.boxShadow =
//                     "0 0 0 2px rgba(59, 130, 246, 0.1)";
//                 }}
//                 onBlur={(e) => {
//                   e.target.style.borderColor = "#e2e8f0";
//                   e.target.style.boxShadow = "none";
//                 }}
//               />
//               <svg
//                 width={isXs ? "16" : "20"}
//                 height={isXs ? "16" : "20"}
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 style={{
//                   position: "absolute",
//                   right: isXs ? "10px" : "14px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   color: "#9ca3af",
//                   pointerEvents: "none",
//                 }}
//               >
//                 <path
//                   d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default CompaniesHeader;
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";

const CompaniesHeader = ({
  selectedStatus,
  setSelectedStatus,
  searchQuery,
  setSearchQuery,
  sidebarOpen = true, // Add sidebarOpen prop with default value
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

  // Local state for dropdown
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Handle dropdown open
  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle dropdown close
  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 217 : 100;

  const dropdownStyles = `
    .dropdown-container {
      position: relative;
      display: inline-block;
    }
  
    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      z-index: 1000;
      margin-top: 2px;
      overflow: hidden;
    }
  
    .dropdown-item {
      padding: 10px 16px;
      cursor: pointer;
      font-family: Roboto;
      font-size: 14px;
      color: #595959;
      border: none;
      background: none;
      width: 100%;
      text-align: left;
      transition: background-color 0.2s ease;
    }
  
    .dropdown-item:hover {
      background-color: #f9fafb;
    }
  
    .dropdown-item.selected {
      background-color: #f3f4f6;
    }
  `;

  const DropdownIcon = () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      style={{ marginLeft: "8px" }}
    >
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // Handle status selection
  const handleStatusSelect = (status) => {
    setSelectedStatus(status);
    handleDropdownClose();
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "stretch", md: "center" },
          p: { xs: 2, sm: 3, md: "24px 32px" },
          borderBottom: "1px solid #f0f1f3",
          backgroundColor: "white",
          gap: { xs: 2, sm: 2, md: 0 },
          // Updated margin-left to use dynamic sidebar width
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease", // Add smooth transition
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "20px", sm: "22px", md: "24px" },
            fontWeight: "600",
            color: "#1a202c",
            mb: { xs: 0, sm: 0, md: 0 },
            textAlign: { xs: "left", sm: "left", md: "left" },
          }}
        >
          All companies
        </Typography>

        {/* Filters and Controls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: { xs: 1.5, sm: 2 },
            flexWrap: "wrap",
          }}
        >
          {/* Filter Dropdowns Row */}
          <Box
            sx={{
              display: "flex",
              gap: { xs: 1, sm: 1.5 },
              flexWrap: "wrap",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {/* Add styles to head */}
            <style dangerouslySetInnerHTML={{ __html: dropdownStyles }} />

            {/* Activity Status Dropdown */}
            <div className="dropdown-container">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: { xs: "6px 12px", sm: "8px 16px" },
                  borderRadius: "6px",
                  fontSize: { xs: "12px", sm: "14px" },
                  backgroundColor: "white",
                  cursor: "pointer",
                  flex: { xs: "1", sm: "0 0 auto" },
                  minWidth: { xs: "0", sm: "120px" },
                  justifyContent: "center",
                  fontFamily: "Roboto",
                  border: "1px solid #DDDDDD",
                  fontWeight: 600,
                  color: "#595959",
                }}
                onClick={handleDropdownClick}
              >
                {selectedStatus}
                <DropdownIcon />
              </Box>

              {/* Custom Dropdown Menu */}
              {open && (
                <div className="dropdown-menu">
                  <button
                    className={`dropdown-item ${
                      selectedStatus === "All" ? "selected" : ""
                    }`}
                    onClick={() => handleStatusSelect("All")}
                  >
                    All
                  </button>
                  <button
                    className={`dropdown-item ${
                      selectedStatus === "Active" ? "selected" : ""
                    }`}
                    onClick={() => handleStatusSelect("Active")}
                  >
                    Active
                  </button>
                  <button
                    className={`dropdown-item ${
                      selectedStatus === "Inactive" ? "selected" : ""
                    }`}
                    onClick={() => handleStatusSelect("Inactive")}
                  >
                    Inactive
                  </button>
                </div>
              )}
            </div>

            {/* Click outside to close */}
            {open && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 999,
                }}
                onClick={handleDropdownClose}
              />
            )}
          </Box>

          {/* Search and Export Row */}
          <Box
            sx={{
              display: "flex",
              gap: { xs: 1, sm: 2 },
              width: { xs: "100%", sm: "auto" },
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {/* Search Input */}
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                flex: { xs: "1", sm: "0 0 auto" },
              }}
            >
              <input
                type="text"
                placeholder="Search with name"
                value={searchQuery}
                onChange={handleSearchChange}
                style={{
                  padding: isXs ? "8px 40px 8px 12px" : "10px 44px 10px 16px",
                  borderRadius: "6px",
                  fontSize: isXs ? "13px" : "14px",
                  width: "100%",
                  backgroundColor: "white",
                  outline: "none",
                  transition: "all 0.2s ease",
                  boxSizing: "border-box",
                  fontFamily: "Roboto",
                  border: "1px solid #DDDDDD",
                  fontWeight: 400,
                  color: "#848694",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#3b82f6";
                  e.target.style.boxShadow =
                    "0 0 0 2px rgba(59, 130, 246, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
              <svg
                width={isXs ? "16" : "20"}
                height={isXs ? "16" : "20"}
                viewBox="0 0 24 24"
                fill="none"
                style={{
                  position: "absolute",
                  right: isXs ? "10px" : "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#9ca3af",
                  pointerEvents: "none",
                }}
              >
                <path
                  d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CompaniesHeader;
